import React from "react";
import { price } from "../data/landing";
import { CtaButton } from "./CtaButton";
const beats = ["Un lápiz.", "Una hoja.", "Una consigna.", "Diez minutos para ti."];
export function FinalCta() {
  return <section className="mx-auto max-w-2xl px-5 py-16 text-center md:py-24" data-id="element-63" data-mp="19f7cz0l765b9">
      <h2 className="font-display text-2xl font-bold leading-snug text-ink md:text-3xl" data-id="element-64" data-mp="15dltuxi2kusm">
        A veces no necesitas tener todas las respuestas.
      </h2>
      <p className="mt-4 text-lg text-muted" data-id="element-65" data-mp="1jbai8fbcik2f">
        A veces necesitas simplemente un espacio para detenerte y explorar lo que está pasando dentro de ti.
      </p>
      <ul className="mt-6 space-y-1 font-display text-xl text-plum" data-id="element-66" data-mp="1t1wp9l4zy29i">
        {beats.map(b => <li key={b} data-id="element-67" data-mp="1o4wif80bovhc">{b}</li>)}
      </ul>
      <p className="mt-6 text-muted" data-id="element-68" data-mp="1o67mza1le79i">Eso es lo que queremos ofrecerte con esta colección.</p>

      <div className="mx-auto mt-10 max-w-md rounded-3xl bg-paper p-6 shadow-sm sm:p-8" data-id="element-69" data-mp="221jpi3lzp20z">
        <p className="font-display text-xl font-bold text-ink" data-id="element-70" data-mp="1x6cr9bbhopjg">MegaPack Arteterapia +50 Técnicas</p>
        <p className="mt-1 text-muted" data-id="element-71" data-mp="n7p61dy6nbjs">6 volúmenes + 3 bonos</p>
        <p className="mt-4 text-sm font-extrabold uppercase tracking-wide text-muted" data-id="element-72" data-mp="s5qmdr484wrk">Hoy por</p>
        <p className="font-display text-4xl font-bold text-plum" data-id="element-73" data-mp="x2que7kmw9lb">{price}</p>
        <div className="mt-6" data-id="element-74" data-mp="123ejuot7sidf">
          <CtaButton label="¡Quiero mi MegaPack ahora!" href="#" note="Pago mediante Mercado Pago · Producto digital" data-id="element-75" data-mp="123myom8wdxr9" />
        </div>
      </div>
    </section>;
}